export const autoGenQuestionResponseMock = "This is a mock random question?";

export const GENERIC_ERROR_MESSAGE =
  "Something went wrong. Please try again later.";
export const DEFAULT_AI_MESSAGE =
  "Hello! How can I assist you today? Please type a question or message.";

export const REPORTS_INTRO_MESSAGE =
  "Here are some reports that provide further insights on this topic:";
export const REPORT_INTRO_MESSAGE =
  "Take a look at this report for deeper insights on this topic:";
export const REPORTS_NULL_MESSAGE =
  "We couldn't find any reports on this topic at the moment.";
export const REPORTS_ERROR_MESSAGE =
  "Something went wrong while searching for reports. Please try again later.";

// Markdown renderer allowed elements
// Restrict allowed markdown elements to simple formatting for safety.
// We enable bold, italics, lists, line breaks, emphasis, strong, paragraphs, headings and links.
// Code blocks / raw HTML are intentionally not rendered to avoid XSS risk.
export const MARKDOWN_ALLOWED_ELEMENTS = [
  "p",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  "br",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];
